import { createContext, useContext } from "react"

interface AuthContextType {
	// user: {},
	// setUser: (u:string) => void,
	login: (d:{}) => void,
	isAuth: boolean,
	user: {
		email: string,
		username:string
	},
	logout: ()=> void
	// checkTokenExist: () => boolean,
	// saveUserToLocalStorage: (d: {}) => void
}
export const AuthContext = createContext<AuthContextType>({} as AuthContextType)